import React, { createContext, useContext, useRef } from 'react';

const SectionContext = createContext();

export function useSection() {
    return useContext(SectionContext);
}

export function useSetSection(section) {
    const sectionRef = useContext(SectionContext);
    sectionRef.current = section;
}

export default function SectionProvider(props) {
    const section = useRef();

    return (
        <SectionContext.Provider value={section}>
            {props.children}
        </SectionContext.Provider>
    );
}
